/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal.show[_ngcontent-%COMP%]{display:block}.modal-dialog[_ngcontent-%COMP%]{max-width:90%}.modal-body[_ngcontent-%COMP%]{max-height:70vh;overflow-y:auto}"];
export { styles as styles };
